export default {
  mailingListTitle: 'Mailing List',
  name: 'Name',
  email: 'Email address',
  addToMailingList: 'Sign up for our newsletter and stay up to date on the latest changes and new features as they\'re released.',
  emailRequired: 'Enter your email address',
  invalidEmailAddress: 'Enter a valid email address',
  addedToMailingList: 'You have been added to the mailing list :)',
  beInTouch: 'We will reach out regarding your interest.'
}
